import client from '../../../services/session/apiClient';


/**
 * TODO make this return type more reasonable
 * loads a single post, and some of its parents and replies
 * @param {string} postId -
 * @return {Promise.<{post: PostMessage}>}
 */
export async function post(postId) {
  return (await client.get('/social/post', { params: {id} })).data;
}

/**
 *
 * @param {PostQuery} query
 * @param {string}    [pagination]
 * @param {number}    [limit]
 * @return {Promise.<{posts: Array.<PostMessage>, [next]: string, [previous]: string}>}
 */
export async function posts({
  query,
  pagination,
  limit
}) {
  return (await client.post('/social/post', { query, pagination, limit })).data
}

/**
 *
 * @param {PostQuery} query
 * @param {string}    [pagination]
 * @param {number}    [limit]
 * @return {Promise.<{posts: Array.<PostMessage>, [next]: string, [previous]: string}>}
 */
export async function rootPosts({
  query,
  pagination,
  limit
}) {
  return (await client.post('/social/rootPosts', { query, pagination, limit })).data;
}

/**
 *
 * @param {PostQuery} query
 * @param {string}    [pagination]
 * @param {number}    [limit]
 * @return {Promise.<{posts: Array.<PostMessage>, [next]: string, [previous]: string}>}
 */
export async function publishedResponses({
  query,
  pagination,
  limit
}) {
  return (await client.post('/social/publishedResponses', {
    query: {
      provider: !!query.chatterProvider ? query.chatterProvider : [],
      ...query
    }, pagination, limit
  })).data;
}


/**
 *
 * @param {PostQuery} query
 * @return {Promise.<{AccountMetrics}>}
 */
export async function accountMetrics({
  query
}) {
  return (await client.post('/social/stats', {...query})).data;
}


/**
 *
 * @param {PostQuery} query
 * @param {string}    pagination
 * @param {number}    [limit]
 * @return {Promise.<{count: number}>}
 */
export async function count({
  query,
  pagination,
}) {
  return (await client.post('/social/count', { query, pagination })).data;
}

/**
 *
 * load
 * @param {string} postId
 * @return {Promise.<{root: PostMessage}>}
 */
export async function rootPost({
  postId,
  socialPublishingId
}) {
  return (await client.post('/social/rootPost', { postId, socialPublishingId })).data
}


/**
 * TODO: Add more type def stuff here as some point?
 * @typedef {Object} PostMetrics
 * @property {string} PostID
 */

/**
 * Given a post ID, obtain metrics about said post. Most likely, this is the root post.
 *
 * @param {string} postId
 * @returns {Promise<{metrics: <PostMetrics>}>}
 */
export async function rootPostMetrics({postId}) {
  try {
    const result = (await client.post('/social/rootPost/metrics', { postId }));
    return result.data
  } catch (err) {
    if (err.message.includes("Request failed with status code 401")) {
      return {error: 401}
    } else if (err.message.includes("Request failed with status code 403")) {
      return {error: 403}
    } else if (err.message.includes("404")) {
      return {error: 404}
    } else {
      // Example could be that the requested data is no longer available, i.e. too old of a post?
      console.error(err);
      return {error: 500}
    }
  }
}


/**
 *
 * load
 * @param {string} postId
 * @param {string} [sortDirection="DESC"]
 * @return {Promise.<{pagination: string}>}
 */
export async function createPaginationToken({
  postId,
  sortDirection = "DESC"
}) {
  return (await client.post(`/social/pagination?sortDirection=${sortDirection}`, { postId })).data
}

/**
 *
 * @param {{
 *   postId: string,
 *   [nestedReplies]: boolean
 * }} query
 * @param {string}    [pagination]
 * @param {number}    [limit]
 * @return {Promise.<{replies: Array.<PostMessage>, hasNext: boolean, next: string, previous: string}>}
 */
export async function replies({
  query,
  pagination,
  limit
}) {
  return (await client.post('/social/replies', { query, pagination, limit })).data
}
